import { API, graphqlOperation } from "aws-amplify";
import { switchCompany, SwitchCompanyMutation, SwitchCompanyMutationVariables } from "../../../graphql";

export const SaveUserPreferenceMutation = async (input:SwitchCompanyMutationVariables):Promise<NonNullable<SwitchCompanyMutation>['switchCompany']>=>{
    try {
        const response = await API.graphql(
            graphqlOperation(switchCompany, {
                companyid: input.companyid,
                financialyearid: input.financialyearid
            })
        ) as {data: SwitchCompanyMutation};
        return response.data.switchCompany;
    } catch (error) {
        throw error;
    }
}
